'use strict';

var React              = require('react'),
    _                  = require('underscore'),
    classnames         = require('classnames'),
    ApplicationActions = require('js/shared/actions/application-actions.js');

var DropdownInput = React.createClass({

  propTypes: {
    title: React.PropTypes.string.isRequired,
    subtitle: React.PropTypes.string,
    fieldName: React.PropTypes.string.isRequired,

    placeholderError: React.PropTypes.string,

    options: React.PropTypes.arrayOf(React.PropTypes.any),

    value: React.PropTypes.number,

    handleChange: React.PropTypes.func,

    onReview: React.PropTypes.bool,
    hasError: React.PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      value: null,
      handleChange: null,
      onReview: false,
      subtitle: null
    };
  },

  getInitialState: function() {
    return {
      value: this.props.value,
      focusedIndex: 0,
      placeholderError: "Please select from the dropdown.",
      collapsed: true
    };
  },

  inputKeyDownMap: {
    38: '_focusPrevious',
    40: '_focusNext',
  },

  optionKeyDownMap: {
    38: '_focusPrevious',
    40: '_focusNext',
    13: '_selectOption'
  },

  _handleKeyDown: function(event) {
    var handlerName = this.inputKeyDownMap[event.keyCode];
    if (!handlerName)
      return;
    event.preventDefault();
    this[handlerName].call(this);
  },

  _updateToOption: function(option) {
    var key = (typeof option === "string") ? option : option.key;

    this.setState({
      value: key
    });

    if (this.props.handleChange !== null) {
      this.props.handleChange(key);
    }
    else {
      ApplicationActions.updateField(this.props.fieldName, key);
    }
  },

  _getCurrentChildList: function() {
    return this.props.options;
  },

  focusOption: function() {
    var index = this.state.focusedIndex;
    var optionNode = this.refs.list.getDOMNode().childNodes[index];
    if (index === null || this.refs.list.getDOMNode().childNodes[index] === undefined) return;
    else optionNode.focus();
  },

  _selectInput: function() {
    this.refs.input.getDOMNode().select();
  },

  _handleOptionKeyDown: function(child_idx, event) {

    var handlerName = this.optionKeyDownMap[event.keyCode];
    if (!handlerName) {
      // if the user starts typing again while focused on an option, move focus
      // to the input, select so it wipes out any existing value
      this._selectInput();
      return;
    }
    event.preventDefault();
    this[handlerName].call(this, child_idx);
  },

  _focusPrevious: function(child_idx) {
    var last = this._getCurrentChildList() - 1;
    var index = this.state.focusedIndex == null ?
      last : this.state.focusedIndex - 1;
    this._focusOptionAtIndex(index);
  },

  _focusNext: function() {
    var index = this.state.focusedIndex == null ?
      0 : this.state.focusedIndex + 1;
    this._focusOptionAtIndex(index);
  },

  _selectOption: function(child_idx) {
    this._updateToOption(this._getCurrentChildList()[child_idx]);
    this._selectInput();
    this.setState({
      collapsed: true
    });
  },

  _focusOptionAtIndex: function(index) {
    var length = this._getCurrentChildList().length;
    if (index === -1)
      index = length - 1;
    else if (index === length)
      index = 0;
    this.setState({
      focusedIndex: index
    }, this.focusOption);
  },

  _handleExpandButton: function(evt) {
    this.setState({
      collapsed: !this.state.collapsed
    });
  },

  _renderOption: function(element, i) {
    var dropdownItemClassNames = classnames({
      "QuestionInput-dropdown-item": true,
      "QuestionInput-dropdown-item--focus": this.state.focusedIndex === i
    });

    var key = (typeof element === 'string') ? element : element.key;
    var value = (typeof element === 'string') ? element : element.value;


    return (
      <div
        className={dropdownItemClassNames}
        key={key}
        value={value}
        tabIndex={-1}
        onKeyDown={this._handleOptionKeyDown.bind(this, i)}
        onClick={this._selectOption.bind(this, i)}>
        {value}
      </div>
    );
  },

  _renderOptions: function(elements) {
    return _.map(elements, (elem, i) => this._renderOption(elem, i));
  },

  render: function() {
    var titleClasses = classnames({
      'QuestionInput-title': true,
      'QuestionInput-title--compact': this.props.onReview || this.props.subtitle === null,
      'QuestionInput-title--placeholder': this.state.value === null  && !this.props.onReview && this.props.subtitle === null,
      'QuestionInput-title--review': this.props.onReview
    });


    var dropdownListClasses = classnames({
      'QuestionInput-dropdown': true,
      'QuestionInput-dropdown--collapsed': this.state.collapsed,
      'QuestionInput-dropdown--review': this.props.onReview,
      'QuestionInput-dropdown--placeholder': this.props.subtitle && !this.props.onReview,
    });

    var value = "";
    if (this.state.value !== null) {
      if (typeof this.props.options[0] === "string") {
        value = this.state.value;
      }
      else {
        value = _.findWhere(this.props.options, {key: this.state.value}).value;
      }
    }

    var optionsList = null;
    if (!this.state.collapsed) {
      optionsList = this._renderOptions(this._getCurrentChildList());
    }

    var inputClasses = classnames({
      'QuestionInput-textField': true,
      'QuestionInput-textField--review': this.props.onReview
    });

    var subtitle = null;
    if(!this.props.onReview) {
      subtitle = <div className="QuestionInput-subtitle">
        {this.props.subtitle}
      </div>;
    }

    var chevronClassNames = classnames({
        "fa": true,
        "fa-chevron-down": this.state.collapsed,
        "fa-chevron-up": !this.state.collapsed
    });

    var collapseButtonClassNames = classnames({
      "QuestionInput-dropdown-collapseButton": true,
      "QuestionInput-dropdown-collapseButton--placeholder": !this.props.onReview && this.props.subtitle !== null,
      "QuestionInput-dropdown-collapseButton--review": this.props.onReview,
    });

    return (
      <div style={{position: "relative"}}>
        <div
          className={titleClasses}>
          {this.props.title}
        </div>
        {subtitle}

        <div>
          <input
            className={inputClasses}
            ref="input"
            type="text"
            value={value}
            tabIndex={0}
            onKeyDown={this._handleKeyDown}
            onClick={this._handleExpandButton}
            readOnly />
        </div>
        <div style={{position: "relative"}}>
          <div
            ref="list"
            className={dropdownListClasses}>
            {optionsList}
          </div>
        </div>
        <div
          className={collapseButtonClassNames}
          onClick={this._handleExpandButton}>
          <i className={chevronClassNames}></i>
        </div>
      </div>
    );
  }
});

module.exports = DropdownInput;



/** WEBPACK FOOTER **
 ** ./js/screens/form/input/dropdown.jsx
 **/